import { gql } from '@apollo/client'

export const CORE_USER_PROFILE_FIELDS = gql`
  fragment CoreUserProfileFields on UserProfile {
    uid
    bio
    location
    birthday
    identityVibe {
      id
      vibe
    }
    profileVisibility
    locationVisibility
    birthdayVisibility
    createdAt
    updatedAt
    userInfo {
      uid
      username
      avatar {
        url
        small
        card
      }
    }
    topics {
      id
      label
      category
    }
    topGenres(limit: 5) {
      name
      weight
      viewCount
    }
  }
`

export const USER_PROFILE_SOCIAL_FIELDS = gql`
  fragment UserProfileSocialFields on UserProfile {
    followerCount
    followingCount
    viewerContext {
      isOwner
      isFollowing
      isFollowedBy
      visibilityLevel
    }
    inProgress(limit: 10) {
      mediaId
      uid
      position
      lastPlayed
      watchedCount
      hiddenByUser
      hiddenFromContinue
      media {
        mediaId
        duration
        contentFeatured(language: $contentLanguage, limit: 1) {
          contentId
          contentType
          title
          path(format: RELATIVE)
          contentAssetReferences(
            contentAssetReferences: [{ type: "keyart-no-text" }]
            limit: 1
          ) {
            asset {
              renderUrl
              width
              height
            }
          }
          imageContentRelationships(
            types: ["d6-keyart-no-text", "d6-poster-image"]
            language: ["en", "_primary"]
          ) {
            type
            image {
              url
            }
          }
        }
      }
    }
  }
`

export const USER_PROFILE_SUMMARY_FIELDS = gql`
  fragment UserProfileSummaryFields on UserProfile {
    uid
    bio
    userInfo {
      uid
      username
      avatar {
        url
        small
        card
      }
    }
    identityVibe {
      id
      vibe
    }
  }
`
